import LeftMenu from 'mk2/apps/blogs/components/LeftMenu';
import { Props } from 'mk2/apps/forum/containers/ForumFeed/ForumFeedPage';
import { BrandDaysPosts } from 'mk2/apps/home/components/BrandDaysPosts';
import React from 'react';
import styles from './ForumFeedRight.mscss';

export class ForumFeedRight extends React.PureComponent<Props> {
    public render() {
        const {
            brandDaysCampaign, brandDaysPosts, location,
        } = this.props;

        const showBrandDays = !!brandDaysCampaign && brandDaysPosts.length > 0;
        return (
            <div className={styles.ForumFeedRight}>
                {showBrandDays && (
                    <BrandDaysPosts
                        className={styles.ForumFeedRight__brandDaysPosts}
                        brandDaysCampaign={brandDaysCampaign}
                        brandDaysPosts={brandDaysPosts}
                    />
                )}

                <LeftMenu location={location} mergedForumAndGroups />
            </div>
        );
    }
}
